import React from "react";
import ProfilePage from "../../components/settings/profile/ProfilePage";

const Profile = () => {
  return (
    <section>
      <ProfilePage />
     
    </section>
  );
};

export default Profile;
